module.exports = __webpack_public_path__ + "static/img/Zhb.9806df0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Zhb.jpg
// module id = uu/k
// module chunks = 1